var _style, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.0706,
    y1: 513.3487,
    x2: 0.9294,
    y2: 513.3487,
    gradientTransform: "matrix(120.9489 -120.9493 241.095 60.676 -123499.9844 -30645.8164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09677,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    style: {
      stopColor: "#238AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    style: {
      stopColor: "#557BDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#7472E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#806EE3"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,512 256.9,255.1 512,512  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.4633,
    y1: 512.6553,
    x2: 3.4633,
    y2: 512.6553,
    gradientTransform: "matrix(70.2472 -70.2468 65.0594 75.8484 -33419.9727 -38678.4453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1183,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4178,
    style: {
      stopColor: "#3C83DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6962,
    style: {
      stopColor: "#6D74E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#806EE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#806EE3"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,0 256.9,0 0,277.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.09752709,
    y1: 512.4517,
    x2: 1.9025,
    y2: 512.4517,
    gradientTransform: "matrix(238.2216 -238.2216 238.2216 238.2216 -122140.1094 -121629.6484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#D0609A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    style: {
      stopColor: "#E1725C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    style: {
      stopColor: "#EE7E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#F58613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#F88909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F88909"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "256.9,0 0,270.5 0,512 256.9,255.1 512,0  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.9dfc74a1b017324341dac0dba48cca92.svg";
export { ForwardRef as ReactComponent };